import styled from 'styled-components/native';

export default {
  RetryBtnGroup: styled.View`
    margin-top: 10px;
  `,
};
